import { render, staticRenderFns } from "./index--device.vue?vue&type=template&id=851724ca&scoped=true&"
import script from "./index--device.vue?vue&type=script&lang=js&"
export * from "./index--device.vue?vue&type=script&lang=js&"
import style0 from "./index--device.vue?vue&type=style&index=0&id=851724ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851724ca",
  null
  
)

export default component.exports